import { IPremiumConfigData } from 'types/administration/pricing/underwriterProfileInterfaces/IPremiumConfig';
import { IEndorsementConfigData } from 'types/administration/pricing/underwriterProfileInterfaces/IEndorsementConfig';
import { ISimultaneousIssuePremiumData } from 'types/administration/pricing/underwriterProfileInterfaces/ISimultaneousIssuePremium';
import { IOtherTitleFeeConfigurationData } from 'types/administration/pricing/underwriterProfileInterfaces/IOtherTitleFeeConfiguration';
import React from 'react';
import { Grid } from 'ui-toolkit';
import { EndorsementsViewer } from './viewers/endorsements/EndorsementsViewer';
import { PremiumsViewer } from './viewers/premiums/PremiumsViewer';
import { OtherTitleFeesViewer } from './viewers/otherTitleFees/OtherTitleFeesViewer';
import { SimultaneousIssueViewer } from './viewers/simultaneousIssue/SimultaneousIssueViewer';

interface IUnderwriterProfileBottomLevelDataProps {
  premiumConfig: IPremiumConfigData;
  endorsementConfig: IEndorsementConfigData;
  simultaneousIssue?: ISimultaneousIssuePremiumData;
  otherTitleFeeConfig: IOtherTitleFeeConfigurationData[];
}

export const UnderwriterProfileBottomLevelData: React.FC<IUnderwriterProfileBottomLevelDataProps> = ({
  premiumConfig,
  endorsementConfig,
  otherTitleFeeConfig,
  simultaneousIssue,
}) => (
  <Grid>
    <EndorsementsViewer endorsementConfig={endorsementConfig} />
    <PremiumsViewer premiumConfig={premiumConfig} />
    <OtherTitleFeesViewer otherTitleFeeConfig={otherTitleFeeConfig} />
    {simultaneousIssue && <SimultaneousIssueViewer simultaneousIssue={simultaneousIssue} />}
  </Grid>
);
